import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Sidebar from '@/components/feature/Sidebar';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotTopics from './components/HotTopics';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotTopics />
        <section className="py-14 bg-background-50">
          <div className="container-custom">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1 min-w-0">
                <LatestArticles />
              </div>
              <div className="w-full lg:w-[320px] flex-shrink-0">
                <Sidebar />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}